module.exports = __webpack_public_path__ + "media/brands/husqvarna-55e08c27.png";